<tgrid-layer-header [layer]="this" [additionIcons]="iconConfig()">


  <div class="legend">
    <span class="info-message">Outage Days</span>
    <div class="legend-bar"></div>
    <div class="legend-container">
      <div class="legend-labels">
        <span>{{ legendBounds().min }}</span>
        <span>{{ legendBounds().max | number }}</span>
      </div>
    </div>

  </div>


</tgrid-layer-header>
